import React from "react"

import "./Contact.scss"

const BannerImage = (props) => {
  return (
    <section className="contact">
      <div className="contact__image-section">
        <div className="contact__image-section__image" style={{ backgroundImage: `url(${props.backgroundImage.localFile.childImageSharp.fluid.src})` }}>
          <div className="contact__image-section__container">
            <div className="contact__image-section__container__text">
              {props.title}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BannerImage
